import type { AuthContextProps } from 'react-oidc-context';

export type AuthUser = AuthContextProps['user'];

/** APIs accept a token for this long after it expires, the default clock-skew allowance. */
const EXPIRY_ALLOWANCE_SECONDS = 5 * 60;

/**
 * The `Authorization` header for the signed-in user, or no header when nobody is signed in or the
 * access token expired longer ago than APIs accept. Edge APIs treat a call without a token as
 * anonymous; an endpoint that requires a user answers 401.
 */
export const authorizationHeader = (user: AuthUser): Record<string, string> =>
  user?.access_token && (user.expires_in ?? 0) > -EXPIRY_ALLOWANCE_SECONDS
    ? { Authorization: `Bearer ${user.access_token}` }
    : {};
